import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import { injectable } from 'inversify';
import type { NumberTuner } from '../NumberTuner';
import { NumberTuneCommand } from './NumberTune.command';
import type { ITuneCommandFactory } from './interfaces';

@injectable()
export class NumberTuneCommandsFactory implements ITuneCommandFactory<ICommand, NumberTuner, number> {
  public createCommand(tuner: NumberTuner, descriptor: string, val: number, prevVal?: number): ICommand {
    if (prevVal === undefined) {
      throw new Error('Previous value is obligatory for Number Tune Command');
    }
    return new NumberTuneCommand(tuner, descriptor, val, prevVal);
  }
}
